export class Shirt {
	
	constructor(
		public name: string,
		public topic: string,
		public description: string,
		public src: string,
		public price: number
	) {}
	
}
